<template>
  <v-card>
    <v-card-title primary-title class="blue-grey lighten-5">
      <slot name="title"></slot>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <div class="subheading mt-2 mb-5 ml-5 mr-5">
        <slot name="body"></slot>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="blue-grey lighten-5">
      <v-btn @click.stop="$emit('close')">$t('buttons.cancel')</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :color="confirmButtonColor || 'primary'"
        @click.stop="confirm"
        :loading="isBusy"
        :disabled="!confirmEnabled"
      >
        {{confirmButton || $t('buttons.confirm')}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
module.exports = {
  name: 'confirmation-modal',
  props: ['title', 'confirmButton', 'isBusy', 'confirmEnabled', 'confirmButtonColor'],
  methods: {
    confirm () {
      this.$emit('confirmed')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ConfirmationModal.vue